export const nextMonotonicNumber = (
  explicitNumber: number | undefined,
  currentCounter: number,
): { assignedNumber: number; nextCounter: number } => {
  if (explicitNumber !== undefined) {
    return {
      assignedNumber: explicitNumber,
      nextCounter: Math.max(currentCounter, explicitNumber),
    };
  }

  const nextCounter = currentCounter + 1;

  return {
    assignedNumber: nextCounter,
    nextCounter,
  };
};
